import {ChangeDetectionStrategy, Component, output} from '@angular/core';
import {FormControl, ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {ElciaDatePicker} from '../../../../components/date-picker/date-picker';
import {NumericInput} from '../../../../components/numeric-input/numeric-input';
import {PriceCoefficientFormValue} from '../../models/price-coefficient-form-value';

@Component({
  selector: 'elcia-price-coefficient-form',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, TranslatePipe, ElciaDatePicker, NumericInput],
  templateUrl: './price-coefficient-form.html',
})
export class PriceCoefficientForm {
  readonly onSubmit = output<PriceCoefficientFormValue>();

  protected readonly coefficient = new FormControl<number | null>(null, [
    Validators.required,
    Validators.min(0.01),
  ]);
  protected readonly startDate = new FormControl<Date | null>(null, Validators.required);
  protected readonly endDate = new FormControl<Date | null>(null);

  submit(): void {
    if (this.coefficient.invalid || this.startDate.invalid) {
      this.coefficient.markAsTouched();
      this.startDate.markAsTouched();
      return;
    }

    this.onSubmit.emit({
      coefficient: this.coefficient.value!,
      startDate: this.startDate.value!,
      endDate: this.endDate.value,
    });
  }
}
